import { useQuery } from "hooks/useQuery";
import { getLabelCount } from "../service";

export const useLabelCount = (slug = null, selectedLabel = "") => {
  const { isLoading, data } = useQuery({
    key: "labelCount",
    queryKey: ["labelCount", slug, selectedLabel],
    queryFn: async () => {
      const response = await getLabelCount(slug);
      if (!response) return { dropdownOptions: [] };

      const dropdownOptions = [];
      let index = 0;

      for (const key in response?.label_count) {
        index = index + 1;

        if (Object.prototype.hasOwnProperty.call(response?.label_count, key)) {
          const value = response?.label_count[key];
          const styleClass = `option-${index + 1}`;

          dropdownOptions.push({
            key: key,
            value: value || 0,
            styleClass,
            isActive: selectedLabel == key,
          });
        }
      }

      return { dropdownOptions };
    },
  });

  return { isLoading, data };
};
